// Web Speech API Umpire Speech Engine

class UmpireVoiceEngine {
  public isMuted: boolean = false;

  public speak(text: string, lang: 'zh-CN' | 'en-US' = 'zh-CN') {
    if (this.isMuted || !('speechSynthesis' in window)) return;
    try {
      window.speechSynthesis.cancel();
      const utterance = new SpeechSynthesisUtterance(text);
      utterance.lang = lang;
      utterance.rate = 1.05;
      utterance.pitch = 1.0;
      window.speechSynthesis.speak(utterance);
    } catch (e) {
      console.warn('Speech synthesis failed:', e);
    }
  }
}

export const umpireVoice = new UmpireVoiceEngine();
